// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var BizCharts$ReactHooksTemplate = require("../common/BizCharts.res.js");
var GenericChartAttribute$ReactHooksTemplate = require("./genericChartAttribute.res.js");

var noDataToDisplay = JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx("p", {
            children: "No data to display"
          }),
      className: "flex justify-center p-60-px"
    });

function WordcloudComponent(props) {
  var chartId = props.chartId;
  var handleWordSelection = function (x) {
    var data = Belt_Option.getExn((x == null) ? undefined : Caml_option.some(x)).data;
    var innerData = Belt_Option.getExn((data == null) ? undefined : Caml_option.some(data)).data;
    var word = Belt_Option.getExn((innerData == null) ? undefined : Caml_option.some(innerData)).text;
    window.location.href = "/responses?keyword=" + (word + ("&visualization_id=" + String(chartId)));
  };
  var data = GenericChartAttribute$ReactHooksTemplate.data(props.chartAttribute);
  var tmp;
  if (data !== undefined) {
    var match = Belt_Option.getWithDefault(Js_json.decodeArray(data), []);
    tmp = match.length !== 0 ? JsxRuntime.jsx(BizCharts$ReactHooksTemplate.Wordcloud.make, {
            data: data,
            onPointClick: handleWordSelection
          }) : noDataToDisplay;
  } else {
    tmp = noDataToDisplay;
  }
  return JsxRuntime.jsx("div", {
              children: tmp
            });
}

var make = WordcloudComponent;

exports.noDataToDisplay = noDataToDisplay;
exports.make = make;
/* noDataToDisplay Not a pure module */
